export const AUDIENCE_FILTER_EVENT_MAX_COUNT = 10

export const ATTRIBUTE_FILTER_MAX_COUNT = 5

export const INPUT_WIDTH_MEDIUM = 80
